module.exports = "./img/54f9b258ca691f67b6b27c4cfd15a3f8.jpg";